@if (!controlName || parentFormGroup.controls[controlName]) {
  <div class="wrapper">
    @if (heading) {
      <div class="heading">{{ heading }}</div>
    }
    <div class="panel flex flex-row justify-evenly items-center" [class.compact]="compact">
      @for (label of buttonLabels; track label; let i = $index) {
        <div
          (click)="onLabelClick(i)"
          class="label flex-1 text-type-10"
          [title]="buttonTooltips[i] || ''"
          [attr.data-testid]="testIdPrefix ? testIdPrefix + label : null"
          [ngClass]="{'selected': isSelected(i), '!uppercase': labelCase === 'capital', '!capitalize': labelCase === 'sentence'}"
          >
          {{ label }}
        </div>
      }
    </div>
  </div>
}
